import {ChangeDetectionStrategy, Component, computed, inject, input, signal} from '@angular/core';
import {PageTitleComponent} from "../../../components/page-title/page-title.component";
import {Divider} from "primeng/divider";
import {
  LoginWithGoogleButtonComponent
} from "../../../components/login-with-google-button/login-with-google-button.component";
import {CustomFormComponent, SubmitFunction} from "../../../components/custom-form/custom-form.component";
import {FormInputsComponent} from "../../../components/form-inputs/form-inputs.component";
import {TextInputComponent} from "../../../components/text-input/text-input.component";
import {FormBuilder, ReactiveFormsModule, Validators} from "@angular/forms";
import {AuthService, LoginResult} from "../../../services/auth/auth.service";
import {
  TermsConditionsCheckboxComponent
} from "../../../components/terms-conditions-checkbox/terms-conditions-checkbox.component";
import {RouterLink} from "@angular/router";
import {isNative} from "../../../utils";
import {whiteDividerDt} from "../../../theme";
import {ErrorMessageComponent} from "../../../components/error-message/error-message.component";
import {loginRoute} from "../../../app.routes";
import {initialSignupRoute} from "../../signup/specific-signup.routes";
import {
  LoginWithAppleButtonComponent
} from "../../../components/login-with-apple-button/login-with-apple-button.component";

@Component({
  imports: [
    PageTitleComponent,
    Divider,
    LoginWithGoogleButtonComponent,
    CustomFormComponent,
    FormInputsComponent,
    TextInputComponent,
    TermsConditionsCheckboxComponent,
    RouterLink,
    ReactiveFormsModule,
    ErrorMessageComponent,
    LoginWithAppleButtonComponent
  ],
  templateUrl: './signin-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class SigninPageComponent {
  constructor(
              private readonly authService: AuthService) {
  }
  public readonly redirectUrl = input<string | undefined>();
  protected readonly redirectUrlWithFallback = computed(() => this.redirectUrl() ?? "/");
  protected readonly loginResult = signal<LoginResult | undefined>(undefined);
  private readonly fb = inject(FormBuilder);

  protected readonly form = this.fb.group({
    email: this.fb.nonNullable.control('', Validators.required),
    password: this.fb.nonNullable.control('', Validators.required),
    conditions: this.fb.nonNullable.control(false, Validators.requiredTrue)
  });

  protected readonly submit: SubmitFunction<{
    email: string;
    password: string;
  }> = async (values) => {
    this.loginResult.set(undefined);
    const result = await this.authService.homeyLogin(values.email, values.password, this.redirectUrlWithFallback());
    this.loginResult.set(result);
  };

  protected readonly isNative = isNative;
  protected readonly whiteDividerDt = whiteDividerDt;
  protected readonly loginRoute = loginRoute;
  protected readonly initialSignupRoute = initialSignupRoute;
}
